<template>
  <div class="main-container alarm-table-height">
    <div style="width: 100%">
      <div v-if="isLoading" class="loading">loading, please wait...</div>
      <div v-else>
        <div class="grid-container">
          <div class="filter_search">
            <h3 class="pagin_style">
              Showing
              {{
                paginationInfo.total > 0
                  ? `${paginationInfo.first} - ${paginationInfo.last}
                    ${paginationInfo.ofText} ${paginationInfo.total} ${
                      paginationInfo.total > 1 ? "Devices" : "Device"
                    }`
                  : "no device"
              }}
            </h3>
            <el-input
              style="width: 30%"
              class="el-input el-input--prefix"
              placeholder="Enter Name or Device ID"
              prefix-icon="el-icon-search"
              v-model="searchTerm"
              clearable
            ></el-input>
          </div>
          <div class="filter_button">
            <p
              @click="toggleDropdown"
              style="position: relative;"
              class="dropbtn"
            >
              <span
                ><i
                  class="fas fa-filter"
                  style="font-size: 20px; margin-left: 10px;"
                ></i
              ></span>
              Filter
              <span style="position: absolute; right: 18px;"
                ><i class="fa fa-caret-down"></i
              ></span>
            </p>
            <div v-show="showDropDownData" class="dropContent">
              <p
                style="font-weight: 600; font-size: 14px; color: orange; margin-bottom: 0px !important;"
              >
                SEVERITY
              </p>
              <p class="radios">
                <label for="Minor">Minor</label>
                <input
                  type="radio"
                  id="Minor"
                  name="Severity"
                  value="minor"
                  v-model="selectedSeverity"
                />
              </p>

              <p class="radios">
                <label for="Major">Major</label>
                <input
                  type="radio"
                  id="Major"
                  name="Severity"
                  value="major"
                  v-model="selectedSeverity"
                />
              </p>

              <p class="radios">
                <label for="Critical">Critical</label>
                <input
                  type="radio"
                  id="Critical"
                  name="Severity"
                  value="critical"
                  v-model="selectedSeverity"
                />
              </p>

              <p
                style="font-weight: 600; font-size: 14px; color: orange; margin-bottom: 0px !important;"
              >
                STATUS
              </p>
              <p class="radios">
                <label for="Open">Open</label>
                <input
                  type="radio"
                  id="Open"
                  name="Status"
                  value="open"
                  v-model="selectedStatus"
                />
              </p>

              <p class="radios">
                <label for="Resolved">Resolved</label>
                <input
                  type="radio"
                  id="Resolved"
                  name="Status"
                  value="resolved"
                  v-model="selectedStatus"
                />
              </p>
              <div class="row">
                <div class="col-md-6">
                  <button class="btn btn-secondary" @click="toggleDropdownOff">
                    Cancel
                  </button>
                </div>
                <div class="col-md-6">
                  <button class="btn btn-primary" @click="filterDataByFilt">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <vue-good-table
          :lineNumbers="true"
          :columns="tableOptions"
          :rows="list"
          :search-options="{
            skipDiacritics: true,
            enabled: true,
            searchFn: searchTable,
            externalQuery: searchTerm
          }"
          :pagination-options="{
            enabled: true,
            perPage: 50
          }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' }
          }"
        >
          <template slot="table-row" slot-scope="props">
            <div>
              <span v-if="props.column.field == 'name'">{{
                props.row["name"] ? props.row["name"] : "---"
              }}</span>
              <span v-if="props.column.field == 'deviceId'">{{
                props.row["deviceId"] ? props.row["deviceId"] : "---"
              }}</span>
              <span v-if="props.column.field == 'fault'">{{
                props.row["fault"] ? props.row["fault"] : "---"
              }}</span>
              <span
                v-if="props.column.field == 'severity'"
                :class="
                  props.row['severity'] == 'Minor'
                    ? 'badge badge-dark'
                    : props.row['severity'] == 'Major'
                    ? 'badge badge-warning'
                    : 'badge badge-warning'
                "
                >{{
                  props.row["severity"] ? props.row["severity"] : "--"
                }}</span
              >
              <span
                v-if="props.column.field == 'status'"
                :class="
                  props.row['status'] == 'RESOLVED'
                    ? 'statusLabel badge badge-success'
                    : 'statusLabel badge badge-danger'
                "
                @click="
                  resolveFunction(props.row['deviceId'], props.row['status'])
                "
                >{{ props.row["status"] ? props.row["status"] : "--" }}</span
              >
              <span v-if="props.column.field == 'startTime && endTime'"
                >{{
                  props.row["startTime"]
                    ? props.row["startTime"].replace(/(?:^|\s)\S/g, function(
                        a
                      ) {
                        return a.toUpperCase();
                      })
                    : "--"
                }}<br />
                {{
                  props.row["endTime"]
                    ? props.row["endTime"].replace(/(?:^|\s)\S/g, function(a) {
                        return a.toUpperCase();
                      })
                    : "--"
                }}</span
              >

              <span v-if="props.column.field == 'resolutionTime'">{{
                dateFormatter(props.row.endTime, props.row.startTime)
              }}</span>
            </div>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
              @paginated-info="paginationInfo = $event"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import format from "date-fns/format";
import { DatePicker } from "element-ui";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  name: "Warnings2",
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchDeviceId: null,
      searchTerm: "",
      showDropDownData: false,
      selectedSeverity: "",
      selectedStatus: "",
      paginationInfo: {},
      items: items,
      resolutionTime: "",
      warningTimerId: null,
      tableOptions: [
        {
          field: "name",
          label: "CUSTOMER NAME",
          sortable: true,
          type: "text",
          filterable: true,
          width: "15%"
        },
        {
          field: "deviceId",
          label: "DEVICE ID",
          sortable: true,
          type: "number",
          filterable: true,
          width: "10%"
        },
        {
          field: "fault",
          label: "FAULT",
          sortable: true,
          type: "text",
          filterable: true,
          width: "15%"
        },
        {
          field: "severity",
          label: "SEVERITY",
          sortable: true,
          type: "text",
          filterable: true,
          width: "15%"
        },
        {
          field: "status",
          label: "STATUS",
          sortable: true,
          type: "text",
          filterable: true,
          width: "15%"
        },
        {
          field: "startTime && endTime",
          label: "START TIME / END TIME",
          sortable: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
          filterable: true,
          width: "18%"
        },
        {
          field: "resolutionTime",
          label: "RESOLUTION TIME",
          sortable: true,
          type: "text",
          filterable: true,
          width: "12%"
        }
      ],
      list: [],
      currentPage: 1,
      isLoading: false,
      filterDate: null
    };
  },
  watch: {
    searchTerm: function(newTerm) {
      this.filterData(newTerm);
    }
  },
  components: {
    "el-date-picker": DatePicker
  },
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"])
  },
  methods: {
    dateFormatter(date1, date2) {
      let endTime = moment(date1, "Do MMM, YYYY h:mm:ssA");
      let startTime = moment(date2, "Do MMM, YYYY h:mm:ssA");
      if (endTime._i != "") {
        const duration = moment.duration(endTime.diff(startTime));
        return duration.humanize();
      } else {
        return "---";
      }
    },
    toggleDropdown() {
      this.showDropDownData = !this.showDropDownData;
    },
    toggleDropdownOff() {
      this.showDropDownData = !this.showDropDownData;
      this.list = this.searchTable;
      this.selectedStatus = "";
      this.selectedSeverity = "";
    },
    filterDataByFilt() {
      if (this.selectedStatus.length > 0) {
        const foundObjects = this.list.filter(obj => {
          const values = Object.values(obj);
          return values.some(value =>
            value.toLowerCase().includes(this.selectedStatus)
          );
        });
        this.list = foundObjects;
        this.selectedStatus = "";
        this.showDropDownData = !this.showDropDownData;
      }
      if (this.selectedSeverity.length > 0) {
        const foundObjects = this.list.filter(obj => {
          const values = Object.values(obj);
          return values.some(
            value =>
              value.toLowerCase().includes(this.selectedStatus) &&
              value.toLowerCase().includes(this.selectedSeverity)
          );
        });
        this.list = foundObjects;
        this.selectedStatus = "";
        this.selectedSeverity = "";
        this.showDropDownData = !this.showDropDownData;
      } else {
        this.init();
        this.showDropDownData = !this.showDropDownData;
      }
    },
    resolveFunction(deviceId, alarmsStatus) {
      const ALARMhttp = this.$httpUtils.AlarmHTTP;
      let systemStatus = alarmsStatus;

      if (systemStatus !== "RESOLVED") {
        let systemDeviceId = {
          DeviceID: deviceId
        };
        const url = `/api/v1/clear-faults`;
        ALARMhttp.put(url, systemDeviceId)
          .then(res => {
            this.showSuccessMsg({
              message: "System alarms resolution successful"
            });
            this.init();
            this.hide();
          })
          .catch(error => {
            this.showErrorMsg({ message: error.response.data.error.message });
          });
      } else {
        this.showInfoMsg({ message: "Device's Alarms already RESOLVED" });
      }
    },
    searchTable(list, tableOptions, cellValue, searchTerm) {
      return (
        Object.values(list)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    sleep(ms) {
      return new Promise(resolve => {
        this.warningTimerId = setTimeout(resolve, ms);
        return this.warningTimerId;
      });
    },
    async init() {
      try {
        const ALARMhttp = this.$httpUtils.AlarmHTTP;
        const url = `/api/v1/get-faults`;
        const res = await ALARMhttp.get(url);
        let { surveillanceByDate } = res.data.data;
        let yo = surveillanceByDate || [];

        let goodWarning = yo.map(v => ({
          deviceId: v.deviceId,
          fault: v.fault,
          severity: v.severity,
          status: v.status,
          startTime: moment(v.startTime).format("Do MMM, YYYY HH:mm:ssA"),
          endTime: v.endTime
            ? `${moment(v.endTime).format("Do MMM, YYYY HH:mm:ssA")}`
            : v.endTime,
          name: v.name
        }));

        this.list = goodWarning;
      } catch (error) {
        console.log("init ==>", error);
      } finally {
        this.isLoading = false;
        this.sleep(300000).then(() => {
          this.init();
        });
      }
    }
  },
  async mounted() {
    this.isLoading = true;
    await this.init();
  }
};
</script>

<style scoped>
.dropbtn {
  position: relative;
  border: 2px solid whitesmoke;
  border-radius: 6px;
  margin-top: 24px;
  background-color: whitesmoke;
  width: 85%;
  font-size: 17px;
  letter-spacing: 2px;
  margin-left: auto;
  padding: 6px 0px;
  cursor: pointer;
  color: rgba(163, 159, 159, 0.788);
}
.dropContent {
  background-color: #fff;
  border: 1px solid whitesmoke;
  border-radius: 12px;
  opacity: 0.9;
  margin-left: 15%;
  padding: 6px 20px 14px;
  position: absolute;
  z-index: 1;
}

.radios {
  display: flex;
  margin-left: 24px;
  margin-bottom: 0px !important;
}
.btn-secondary {
  background-color: rgba(163, 159, 159, 0.788);
  color: #fff;
}
.btn-secondary:hover {
  background-color: rgba(97, 91, 91, 0.788);
  color: #fff;
}
.btn {
  border-radius: 12px;
}

label {
  flex: 1;
  margin-top: 12px;
  font-weight: 100 !important;
}
.grid-container {
  display: grid;
  grid-template-areas: "searchFilter searchFilter searchFilter searchFilter buttonFilter buttonFilter";
  grid-column-gap: 15%;
}
.filter_search {
  grid-area: searchFilter;
}
.filter_button {
  grid-area: buttonFilter;
  margin-top: 18px;
  position: relative;
  display: inline-block;
}
.loading {
  width: 100%;
  padding: 100px 0;
  text-align: center;
}
.badge-success {
  background: #35ae4754 !important;
}
.badge-danger {
  background-color: #eb3b4754 !important;
}
.badge-warning {
  background-color: #f4832171 !important;
}
.badge-info {
  background-color: #6c757d70 !important;
}
.badge-dark {
  background-color: #007bff57 !important;
}
.badge {
  min-width: 123px;
  display: inline-block;
  font-weight: normal;
  text-transform: capitalize;
  font-size: 8pt;
  letter-spacing: 0.0625rem;
  color: #fff;
}
.alarm-table-height {
  height: calc(100vh - 225px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/warnings/Warnings2.vue